import dealer from './dealer';
import dailyCore from './dailyco.core';
import sdAnalytics from './sdAnalytics';

class listener {

    static listen = function (params) {
        let sd = new sdAnalytics();
        window.addEventListener(
            "tg-join-meeting",
            function (event) {
                console.log("tg-join-meeting");
                window.joinMeeting(event);
                sd.chatImpression();
                sd.chatLead();
            },
            false
        );

        window.addEventListener(
            "tg-left-meeting",
            function (event) {
                if (window.tgMeetingState === "left-meeting") {
                    console.log("tg-left-meeting");
                    sd.chatUserMessage(event.data.chatMessages);
                    sd.chatClosed();
                    let dailyCoreObj = new dailyCore();
                    window.tgMeetingState = "left-meeting";
                    dailyCoreObj.setMeetingState("left-meeting");
                    if (window.tgmeetingChildWindow) {
                        window.tgmeetingChildWindow.close();
                    }

                    dealer.sendADF(event).then(function (adfresponse) {
                        if (adfresponse.success === 1) {
                            console.log("ADF sent..");
                        }
                    });
                    let chatroomState = dailyCoreObj.getChatRoomState();
                    if (chatroomState !== "deleted" || chatroomState !== "deleting") {
                        dailyCoreObj.setChatRoomState("deleting");
                        dailyCoreObj.deleteRoom(window.tgDealerId, dealer.getChatSessionId()).then(function (deleteRoomResponse) {
                            if (deleteRoomResponse.success === 1) {
                                if (deleteRoomResponse.result.deleted === true) {
                                    dailyCoreObj.setChatRoomState("deleted");
                                    console.log("Room deleted");
                                }
                            }
                        });
                    }
                }
            },
            false
        );

        let buttonscript = document.getElementById("tgopdId");

        if (!buttonscript) {

            window.onmessage = function (event) {
                if (event.data.eventId === "tg-chat-signal") {
                    if (!window.tgmeetingChildWindow) {
                        window.tgMeetingState = "active";
                        sessionStorage.setItem("tg-chat-state", "active");
                        window.tgmeetingChildWindow = event.source;
                    }
                }
                if (event.data.eventId === "left-meeting") {
                    window.tgMeetingState = "left-meeting";
                    let meetingLeftEvent = new CustomEvent( 
                        "tg-left-meeting"
                    );
                    meetingLeftEvent.data = event.data;
                    window.dispatchEvent(meetingLeftEvent);
                    sessionStorage.setItem("tg-chat-state", "left-meeting");
                }

                if (event.data.eventId === "joined") {
                    window.tgMeetingState = "joined";
                    sessionStorage.setItem("tg-chat-state", "joined");
                    window.tgVChatJoinedOwnerName = event.data.participant;
                    sessionStorage.setItem("tg-chat-participant", event.data.participant);
                }
            }
        }
    }

}

export default listener;